import axios from "axios";

//"https://httpbin.org/post"
export default axios.create({
  baseURL: "https://apitattle.muvi.com/",
});
